<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title>{{'Contribuições Detalhes' | translate}}</ion-title>
  </ion-buttons>
</ion-header>

<ion-content padding *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content padding *ngIf="loaded">
  <div class="remove-border">
    <ion-list *ngFor="let d of detalhes;">
      <ion-item class="list-item">
        <ion-label>
          <h3 class="item-title bold-2">{{d.nome}}</h3>
          <p>{{d.data | dateFormat:"MMMM yyyy"}}</p>
        </ion-label>

        <ion-note slot="end">
          <h3 class="bold-1">{{d.saldo | money | async}}</h3>
        </ion-note>
      </ion-item>
    </ion-list>

    <sem-registro [hidden]="detalhes"></sem-registro>
  </div>
</ion-content>